import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { activateModal } from '../../../store/actions';
import FoldersModal from '../../Favorites/FoldersModal';
import FirstTimeFavoriteModal from '../../Favorites/FirstTimeFavoriteModal';
import svgInline from '../../SvgInline/SvgInline';
import folderIcon from '../icon-folder.svg';
import folderIconActive from '../icon-folder-active.svg';

import './WithFavorites.css';

export const favoritesTypePropLookup = {
  states: 'state',
  regions: 'region',
  counties: 'county',
  communities: 'community',
};

export function mapStateToProps({ favorites, profile }, { favoritesType, ...props }) {
  const item = props[favoritesTypePropLookup[favoritesType]];
  const id = item && item._id ? item._id.toString() : 'missing';
  return {
    id,
    dontShowAgain: favorites.dontShow,
    authenticated: profile.authenticated,
    saved: favorites.folders.savedFolders
      .some(folder => (folder[favoritesType] || []).indexOf(id) !== -1),
  };
}

export function mapDispatchToProps(dispatch, { favoritesType, ...props }) {
  const item = props[favoritesTypePropLookup[favoritesType]];
  const id = item && item._id ? item._id.toString() : 'missing';
  return {
    activateFavoriteModal: () => { dispatch(activateModal(`folders-${id}`)); },

    // Team LOIS has requested the functionality for notifying a user they are not logged
    // into favorites be removed for now. The functionality will be commented out for when
    // they as to have it re-implemented.

    // activateFavoriteModal: whichModal =>
    //   (whichModal === 'folders'
    //     ? dispatch(activateModal(`${whichModal}-${id}`))
    //     : dispatch(activateModal(`${whichModal}-${id}`))
    //   ),
  };
}

export function mergeProps(propsFromState, propsFromDispatch, ownProps) {
  const checkValue =
    (propsFromState.authenticated || propsFromState.dontShowAgain || propsFromState.saved);
  return {
    selectFavoriteModal: () => (checkValue ? propsFromDispatch.activateFavoriteModal('folders') : propsFromDispatch.activateFavoriteModal('first-time')),
    ...propsFromState,
    ...ownProps,
  };
}

export default function withFavorites(WrappedComponent) {
  function WithFavorites({ id, favoritesType, saved, dontShowAgain,
    selectFavoriteModal, ...props }) {
    const item = props[favoritesTypePropLookup[favoritesType]];
    return (
      <li className="with-favorites__container">
        <FoldersModal
          action={saved ? 'remove' : 'save'}
          id={id}
          items={[item]}
          itemType={favoritesType}
          modalName="folders"
          referrer="withFavorites"
        />
        <FirstTimeFavoriteModal
          action={saved ? 'remove' : 'save'}
          id={id}
          items={[item]}
          itemType={favoritesType}
          modalName="first-time"
          dontShowAgain={dontShowAgain}
        />
        <div className="with-favorites__item">
          <WrappedComponent {...props} />
          <div
            data-tip="Add/Remove From Folders"
          >
            <a
              tabIndex="0"
              style={{ height: 24, width: 15 }}
              onClick={selectFavoriteModal}
              className="list-links__save"
            >
              {saved ? svgInline(folderIconActive) : svgInline(folderIcon)}
            </a>
          </div>
        </div>
      </li>
    );
  }

  WithFavorites.propTypes = {
    activateFavoriteModal: PropTypes.func,
    selectFavoriteModal: PropTypes.func,
    favoritesType: PropTypes.string,
    id: PropTypes.string,
    saved: PropTypes.bool,
    dontShowAgain: PropTypes.bool,
    authenticated: PropTypes.bool,
  };

  WithFavorites.displayName = `withFavorites(${WrappedComponent.displayName || WrappedComponent.name})`;

  return connect(mapStateToProps, mapDispatchToProps, mergeProps)(WithFavorites);
}



// WEBPACK FOOTER //
// ./src/components/List/Areas/WithFavorites.js